'use client';

import { MultipleUploader } from '@/components/batchToolsComp/LandingPageIntroUpload/MultipleUploader';
import { useImageProcessing } from '../context/ImageProcessingContext';
import useImageUploader from '../useHook/useImageUploader';

interface UploadWrapperProps {
  nextPageUrlParams?: string;
}

export default function UploadWrapper({
  nextPageUrlParams,
}: UploadWrapperProps) {
  const { clearImages } = useImageProcessing();
  const { handleImageUploadInit } = useImageUploader({ from: 'landingPage' });

  return (
    <MultipleUploader
      nextPageUrlParams={nextPageUrlParams}
      asyncBeforeUpload={() => clearImages()}
      onImagesUpload={handleImageUploadInit}
    />
  );
}
